<template>
  <div class="list1 c-box">
    <div class="content">
      <div class="total pt-6">
        <div><p>総保有ベネポ </p></div>
        <div v-if="pointInfo && pointInfo.totalPoint"><h1>{{ pointInfo.totalPoint | formatInteger }}P</h1></div>
      </div>

      <div class="total-detail">
        <div class="pl-4"><h1>通常ベネポ</h1></div>
        <div><span>{{ pointInfo.noUseLimitPoint | formatInteger }}P</span></div>
      </div>

      <div class="total-detail">
        <div class="pl-4"><h1>利用制限ベネポ</h1></div>
        <div><span>{{ pointInfo.useLimitPoint | formatInteger }}P </span></div>
      </div>

      <div class="total-detail pb-0">
        <div class="pl-8"><h1>リラクサロン限定</h1></div>
        <div><span></span></div>
      </div>
    </div>
    <hr class="w-full" />
    <div class="content">
      <div class="total pt-3">
        <div class="pt-1"><p>獲得予定ベネポ</p></div>
        <div><h1>{{ pointInfo.grantedPoint | formatInteger }}P</h1></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    text: String,
    point: String,
    detail: String,
    acquired: String,
    pointInfo: Object
  }

}
</script>

<style lang="scss" scoped>
@import "./styles.scss"
</style>